import _ from 'lodash';
import classNames from 'classnames';

import React, { useContext, useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { LOADING } from 'state/constants';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  Grid,
  Switch,
  Checkbox,
  Card,
} from '@material-ui/core';
import { ServiceOffer, ServiceOfferDetails, Shooting } from 'models';
import { ShootingContext } from 'contexts';
import { useAuth, useLanguage, useProfile } from 'hooks';
import {
  COLOR,
  ENG,
  SHOOTING_STEPS,
  SERVICE_OFFER_CATEGORY_ICON,
  SERVICE_OFFER_CATEGORY_NAME,
  CARTE_SERVICE_OFFERS,
  SERVICE_OFFER_CATEGORY,
} from 'config/constants';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import { DoneRounded } from '@material-ui/icons';
import { HvPleaseWait } from 'components';
import { getServiceDescriptionIcon, checkIfCovered } from 'utils';
import { images } from 'assets/images';

const useStyles = makeStyles({
  stepContent: {
    position: 'relative',
    minHeight: 100,

    '& .MuiIconButton-root': {
      padding: 0,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 30,
    },
    '& .MuiCheckbox-root': {
      color: '#00bdf2',
    },
  },
  wait: {
    backgroundColor: 'transparent',
  },
  group: {
    marginBottom: 30,

    '&:last-child': {
      marginBottom: 0,
    },

    '& > h1': {
      textAlign: 'center',
    },
  },
  groupItem: {
    flex: 1,
    borderRadius: 4,
    marginBottom: 20,
    cursor: 'pointer',

    '&.Selected': {
      backgroundColor: '#1074BC0A',
    },
  },
  packageContent: {
    cursor: 'pointer',
  },
  recommendedLabel: {
    height: 24,
    color: 'white',
    fontSize: 12,
    lineHeight: '24px',
    textTransform: 'capitalize',
    borderRadius: 10,
    backgroundColor: COLOR.BLUE2,
    boxSizing: 'border-box',
    padding: '0 10px',
    marginLeft: 20,
  },
  moreInfo: {
    width: 'fit-content',
    color: COLOR.BLUE2,
    fontSize: 14,
    textDecoration: 'underline',
    marginTop: 10,
  },
  selectButton: {
    marginLeft: 30,

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  selected: {
    color: '#fff',
    fontSize: '25px !important',
    backgroundColor: '#00BDF2',
    borderRadius: '50%',
    boxSizing: 'border-box',
    padding: 3,
    margin: 2.5,
  },
  editVideo: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  divider: {
    margin: '5px 0',
  },
  servicesContent: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    '@media (max-width: 959px)': {
      justifyContent: 'flex-start',
    },
  },
  serviceTitle: {
    textAlign: 'center',
    marginTop: 5,
    fontFamily: 'FordAntenna-Medium',
    '@media (max-width: 959px)': {
      fontSize: 10,
    },
  },
  serviceDescription: {
    fontSize: 12,
  },
  countContent: {
    position: 'relative',
    width: '100%',
  },
  count: {
    width: 28,
    height: 28,
    borderRadius: 14,
    position: 'absolute',
    top: -4,
    right: 0,
    backgroundColor: COLOR.LIGHT_BLUE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  countNumber: {
    color: COLOR.WHITE,
    fontSize: 12,
    textAlign: 'center',
  },
  serviceItemsContent: {
    marginTop: 20,
  },
  boldFont: {
    fontFamily: 'FordAntenna-SemiBold',
  },
  serviceContainer: {
    display: 'flex',
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
    height: 60,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  selectedServiceContainer: {
    display: 'flex',
    borderRadius: 8,
    border: '3px #00bdf2 solid',
    padding: 12,
    marginBottom: 10,
    height: 60,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  serviceContent: {
    borderRadius: 8,
    padding: 8,
    outline: '1px #bcbbc1 solid',
    marginBottom: 10,
  },
  exampleServiceContent: {
    borderRadius: 8,
    outline: '1px #bcbbc1 solid',
    marginBottom: 10,
  },
  selectedServiceContent: {
    borderRadius: 8,
    // padding: 8,
    borderWidth: 1,
    borderColor: COLOR.GREY,
    backgroundColor: COLOR.WHITE,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    minHeight: 250,
    height: '100%',
    '@media (max-width: 959px)': {
      flexDirection: 'column',
    },
  },
  hideContent: {
    display: 'none',
  },
  serviceNameTitle: {
    fontFamily: 'FordAntenna-Medium',
  },
  selectedServiceTitle: {
    marginBottom: 10,
    fontSize: 15,
    fontFamily: 'FordAntenna-SemiBold',
  },
  serviceTitleRow: {
    flexDirection: 'row',
  },
  servicePriceRow: {
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
  },
  coveredPriceContainer: {
    backgroundColor: COLOR.LIGHT_BLUE,
    borderRadius: 8,
    padding: '8px 10px',
    marginRight: 5,
  },
  originalPriceContainer: {
    borderRadius: 8,
    padding: '8px 10px',
    '& p': {
      color: COLOR.DARK_GREY,
    },
  },
  priceContainer: {
    backgroundColor: COLOR.LIGHT_BLUE,
    borderRadius: 8,
    padding: '8px 10px',
  },
  priceText: {
    color: COLOR.WHITE,
    fontFamily: 'FordAntenna-Regular',
  },
  serviceTooltip: {
    marginLeft: 10,
  },
  tick: {
    position: 'absolute',
    right: 0,
    cursor: 'pointer',
  },
  overlayTick: {
    position: 'absolute',
    right: 20,
    bottom: 20,
    cursor: 'pointer',
    zIndex: 2,
  },
  serviceDivider: {
    width: 24,
    height: 24,
    borderRadius: 14,
    backgroundColor: COLOR.WHITE,
    border: '2px #00BDF2 solid',
  },
  packageDescriptionRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    paddingRight: 10,
  },
  packageDescription: {
    wordWrap: 'break-word',
  },
  freeServicesContent: {
    marginTop: 20,
  },
  tooltipModal: {
    padding: '0px 20px 20px',
    maxWidth: 500,
  },
  beforeImage: {
    position: 'absolute',
    color: COLOR.WHITE,
    left: 20,
    zIndex: 3,
    padding: 2,
    backgroundColor: COLOR.TRANSPARENT_BLACK,
  },
  afterImage: {
    position: 'absolute',
    color: COLOR.WHITE,
    right: 20,
    zIndex: 999,
    padding: 2,
    backgroundColor: COLOR.TRANSPARENT_BLACK,
  },
  imagesRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  twoDcheckboxRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  noServiceWarning: {
    color: COLOR.RED,
    marginTop: 10,
  },
  checkboxContent: {
    width: '100%',
  },
  checkboxRow: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  checkboxText: {
    maxWidth: '80%',
  },
  tabs: {
    marginBottom: 20,
  },
  tab: {
    color: COLOR.BLACK,
  },
  selectedTab: {
    backgroundColor: COLOR.LIGHT_BLUE,
    color: COLOR.WHITE,
  },
  borderContent: {
    border: `1px solid ${COLOR.GREY}`,
    borderRadius: 8,
    padding: 10,
    marginBottom: 10,
  },
  floorplanOptionsContent: {
    alignItems: 'center',
    marginBottom: 10,
  },
  switchRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 5,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  switch: {
    '&>.MuiSwitch-colorPrimary': {
      color: '#00BDF2',
    },
    '&>.MuiSwitch-colorPrimary.Mui-checked': {
      color: 'white',
      backgroundColor: '#00BDF2',
    },
    '&>.MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
      color: 'white',
      backgroundColor: '#00BDF2',
    },
    '&>.MuiSwitch-colorSecondary.Mui-checked': {
      color: 'white',
      backgroundColor: '#00BDF2',
    },
    '&>.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      opacity: 1,
    },
    '&>.MuiSwitch-track': {
      backgroundColor: '#00BDF2',
    },
    marginRight: 5,
    marginLeft: 5,
  },
  root: {
    width: 50,
    height: 30,
    marginRight: 10,
    marginLeft: 10,
    padding: 0,
    '&$checked': {
      color: COLOR.LIGHT_BLUE,
    },
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: 'white',
      '& + $track': {
        opacity: 1,
        border: '6px solid #fff',
      },
    },
    '&$focusVisible $thumb': {
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 29,
    height: 29,
  },
  track: {
    borderRadius: 20,
    opacity: 1,
  },
  saveButton: {
    color: COLOR.WHITE,
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  nextButton: {
    color: COLOR.WHITE,
    '@media (max-width: 767px)': {
      fontSize: 10,
      width: '100%',
    },
  },
  categoryTitle: {
    marginBottom: 10,
    fontFamily: 'FordAntenna-SemiBold',
  },
  servicesRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    overflowX: 'auto',
  },
  buttons: {
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  serviceExample: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderBottomRightRadius: 8,
    borderTopRightRadius: 8,
    '@media (max-width: 959px)': {
      objectFit: 'cover',
      height: 350,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 8,
    },
    '@media (max-width: 600px)': {
      height: 250,
    },
  },
  serviceRightContent: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderBottomRightRadius: 8,
    borderTopRightRadius: 8,
    right: 0,
    '@media (max-width: 959px)': {
      position: 'relative',
    },
  },
  serviceContentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  serviceLeftContent: {
    padding: 8,
  },
  plus: {
    color: COLOR.LIGHT_BLUE,
    width: 20,
    height: 20,
  },
  selectedIcon: {
    color: COLOR.WHITE,
    width: 20,
    height: 20,
  },
  blueCircleIcon: {
    width: 30,
    height: 30,
    borderRadius: 15,
    outline: `1.5px ${COLOR.LIGHT_BLUE} solid`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    '@media (max-width: 767px)': {
      display: 'none',
    },
  },
  backButton: {
    backgroundColor: COLOR.WHITE,
    color: COLOR.LIGHT_BLUE,
    borderColor: COLOR.LIGHT_BLUE,
    marginRight: 20,
    '@media (max-width: 767px)': {
      fontSize: 10,
      marginRight: 5,
    },
  },
});

interface Props {
  setActiveStep: (_: number) => void;
  onCancel: () => void;
}

function ServiceStep({ setActiveStep, onCancel }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();
  const { user, token } = useAuth();
  const dispatch = useDispatch();
  const { profile, loading: loadingProfile } = useProfile(token, user.email);
  const {
    shooting,
    listing,
    serviceOffers,
    updateShootingFields,
    saveShooting,
    validatePackageStep,
    shouldChooseTimeslot,
    brokers,
    ignoreAutoSaisie,
    setIgnoreAutoSaisie,
  } = useContext(ShootingContext);
  const isDraftMode = shooting.state === Shooting.STATE_ENUM.draft;
  const twoDFloorplans = [];
  const threeDFloorplans = [];
  const standardThreeDFloorplans = [];
  const advancedThreeDFloorplans = [];
  let twoDSmallFloorplan;
  let twoDBigFloorplan;
  let threeDSmallFloorplan;
  let threeDFloorplan;
  const carteMeasureService = serviceOffers.find((m: ServiceOffer) => {
    return m?.serviceOffer?.id === CARTE_SERVICE_OFFERS.MEASURE;
  });
  if (serviceOffers) {
    serviceOffers.map((s) => {
      if (s.serviceOffer.service_items?.type === '3D') {
        threeDFloorplans.push(s);
        if (!s.serviceOffer.service_items.withRealFurniture) {
          standardThreeDFloorplans.push(s);
        } else {
          advancedThreeDFloorplans.push(s);
        }
        if (
          s.serviceOffer.service_items.withRealFurniture === false &&
          s.serviceOffer.service_items.isBiggerArea === false
        ) {
          threeDSmallFloorplan = s;
        } else {
          threeDFloorplan = s;
        }
      } else if (s.serviceOffer.service_items?.type === '2D') {
        twoDFloorplans.push(s);
        if (s.serviceOffer.service_items.isBiggerArea) {
          twoDBigFloorplan = s;
        } else {
          twoDSmallFloorplan = s;
        }
      }
      return null;
    });
  }
  const [loading, setLoading] = useState(false);
  const [showTooltipModal, setShowTooltipModal] = useState(false);
  const [tooltipService, setTooltipService] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedService, setSelectedService] = useState(1);
  const [display3DFloorplan, setDisplay3DFloorplan] = useState(false);
  const [twoDFloorplanOption, set2DFloorplanOption] = useState(
    twoDSmallFloorplan || twoDBigFloorplan,
  );
  const [threeDFloorplanOption, set3DFloorplanOption] = useState(
    threeDSmallFloorplan || threeDFloorplan,
  );
  const [is2DBiggerArea, set2DBiggerArea] = useState(false);
  const [is3DWithFurnitures, set3DWithFurnitures] = useState(false);
  const [is3DBiggerArea, set3DBiggerArea] = useState(false);
  const { service_offers } = shooting;
  const isEnglish = language === ENG;
  const ipad_width = 960;
  const fmtAdditionalServices = intl.formatMessage({ id: 'shooting.create.titles.serviceOffers' });
  const fmtFreeServices = intl.formatMessage({ id: 'shooting.create.titles.freeServices' });
  const fmtWithRealFurnitures = intl.formatMessage({
    id: 'deliver.photos.floorplanModal.withRealFurnitures',
  });
  const fmtLargerThan200 = intl.formatMessage({
    id: 'deliver.photos.floorplanModal.largerThan200',
  });
  const fmtDisabledHelper = intl.formatMessage({
    id: 'shooting.create.labels.serviceOfferDisabledHelp',
  });
  const fmtNoServiceAvailable = intl.formatMessage({
    id: 'shooting.create.labels.noServiceAvailable',
  });
  const fmtBefore = intl.formatMessage({ id: 'shooting.create.titles.before' });
  const fmtAfter = intl.formatMessage({ id: 'shooting.create.titles.after' });
  const fmtAddForFree = intl.formatMessage({ id: 'shooting.create.titles.addForFree' });
  const fmtSave = intl.formatMessage({ id: 'shooting.create.buttons.save' });
  const fmtBack = intl.formatMessage({ id: 'shooting.create.buttons.back' });
  const fmtNext = intl.formatMessage({ id: 'shooting.create.buttons.next' });
  const fmtCancel = intl.formatMessage({ id: 'shooting.create.buttons.cancel' });
  const fmtRecommendedServices = intl.formatMessage({
    id: 'shooting.create.titles.recommendedServices',
  });
  const fmtSaveDraft = intl.formatMessage({ id: 'shooting.create.buttons.saveDraft' });
  const fmtFloorplanType = intl.formatMessage({ id: 'shooting.create.labels.floorplanType' });

  useEffect(() => {
    if (service_offers) {
      const selectedFloorplanService = service_offers.find((so) => {
        return so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN;
      });
      if (selectedFloorplanService) {
        if (selectedFloorplanService?.serviceOffer.service_items.type === '3D') {
          setDisplay3DFloorplan(true);
          set3DFloorplanOption(selectedFloorplanService);
          set3DBiggerArea(selectedFloorplanService?.serviceOffer?.service_items?.isBiggerArea);
          set3DWithFurnitures(
            selectedFloorplanService?.serviceOffer?.service_items?.withRealFurniture,
          );
        } else {
          setDisplay3DFloorplan(false);
          set3DFloorplanOption(selectedFloorplanService);
          set2DBiggerArea(selectedFloorplanService?.serviceOffer?.service_items?.isBiggerArea);
        }
      }
      const carteMeasureService = serviceOffers.find((service: any) => {
        return service?.serviceOffer?.id === CARTE_SERVICE_OFFERS.MEASURE;
      });
      const foundExistingCarteMeasureService = shooting.service_offers.find((service: any) => {
        return service?.serviceOffer?.id === CARTE_SERVICE_OFFERS.MEASURE;
      });
      const foundExistingFloorplanService = shooting.service_offers.find((service: any) => {
        return service?.serviceOffer?.category?.id === SERVICE_OFFER_CATEGORY.FLOORPLAN;
      });
      if (
        foundExistingFloorplanService &&
        carteMeasureService &&
        !foundExistingCarteMeasureService
      ) {
        const _serviceOffers = _.cloneDeep(shooting.service_offers);
        const s = new ServiceOffer(carteMeasureService);
        _serviceOffers.push(s);
        updateShootingFields({ service_offers: _serviceOffers });
      }
    }
  }, []);
  useEffect(() => {
    if (!shooting.id && !ignoreAutoSaisie && loadingProfile === LOADING.FINISHED) {
      let user_auto_saisie = profile.automatic_saisie;
      if (listing.broker_id) {
        const selectedBroker = brokers.find((broker) => {
          return broker.id === listing.broker_id;
        });
        if (selectedBroker) {
          user_auto_saisie = selectedBroker.automatic_saisie;
        }
      }
      const pictureUploadServices = serviceOffers.filter((service) => {
        return service.serviceOffer.display_name === SERVICE_OFFER_CATEGORY_ICON.PICTURE_UPLOAD;
      });
      if (user_auto_saisie && pictureUploadServices.length) {
        const _serviceOffers = _.cloneDeep(shooting.service_offers);
        pictureUploadServices.forEach((service) => {
          const foundExistingService = _serviceOffers.find((m: ServiceOffer) => {
            return m.serviceOffer.id === service.serviceOffer.id;
          });
          if (!foundExistingService) {
            _serviceOffers.push(service);
          }
        });
        updateShootingFields({ service_offers: _serviceOffers }, true);
      }
    }
  }, [loadingProfile]);

  const isServiceSelected = (so: ServiceOffer) => {
    return !!shooting.service_offers.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
  };

  const isServiceDisabled = (so: ServiceOffer) => {
    if (so.serviceOffer?.is_global) {
      return false;
    }

    const nonGlobalServiceOffers = service_offers?.filter((m: ServiceOffer) => {
      return !m.serviceOffer.is_global;
    });

    const ngso = nonGlobalServiceOffers.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
    if (ngso) return false;

    const userIds = _.flatten(
      nonGlobalServiceOffers.map((so: ServiceOffer) => {
        return so.serviceOffer.users;
      }),
    );

    const serviceOfferTechs = _.get(so.serviceOffer, 'users', []);

    for (let i = 0; i < serviceOfferTechs.length; i++) {
      const user = serviceOfferTechs[i];
      if (userIds.indexOf(user) !== -1) return false;
    }

    return !!_.intersection(userIds, so.serviceOffer?.users || []).length;
  };

  const onToggleServiceOffer = (so: ServiceOffer, isDisabled: boolean) => {
    if (isDisabled) return;
    const _service_offers = _.clone(service_offers);
    const index = _.findIndex(_service_offers, (m: ServiceOffer) => {
      return so?.serviceOffer?.id === m?.serviceOffer?.id;
    });
    const floorplanSelected = _service_offers.find((m: ServiceOffer) => {
      return m?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN;
    });
    if (index !== -1) {
      if (!(so.serviceOffer.id === CARTE_SERVICE_OFFERS.MEASURE && floorplanSelected)) {
        _service_offers.splice(index, 1);
      }
      const existingCarteMeasureIndex = _.findIndex(_service_offers, (m: ServiceOffer) => {
        return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      if (
        so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN &&
        existingCarteMeasureIndex !== -1
      ) {
        _service_offers.splice(existingCarteMeasureIndex, 1);
      }
      if (so.serviceOffer.display_name === SERVICE_OFFER_CATEGORY_ICON.PICTURE_UPLOAD) {
        setIgnoreAutoSaisie(true);
      }
    } else {
      _service_offers.push(so);
      const existingCarteMeasureIndex = _.findIndex(_service_offers, (m: ServiceOffer) => {
        return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      if (
        so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN &&
        carteMeasureService &&
        existingCarteMeasureIndex === -1
      ) {
        _service_offers.push(carteMeasureService);
      }
    }
    updateShootingFields({ service_offers: _service_offers }, true);
  };

  const onPreviousStep = () => {
    setActiveStep(SHOOTING_STEPS.PACKAGE);
  };

  const onUpdate = () => {
    if (!validatePackageStep()) return;

    if (shooting.state !== Shooting.STATE_ENUM.draft && shouldChooseTimeslot()) {
      setActiveStep(SHOOTING_STEPS.SELECT_DATETIME);
    } else {
      saveShooting();
    }
  };
  const checkIfChild = (so: ServiceOffer) => {
    const foundService = service_offers.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
    if (foundService) {
      return foundService.is_child;
    }
    return false;
  };
  const onNextStep = () => {
    if (validatePackageStep()) {
      setActiveStep(SHOOTING_STEPS.CLIENT_INFO);
    }
  };
  const onClickCategory = (key: number, service: ServiceOfferDetails) => {
    let services = selectedServices;
    if (services.includes(service)) {
      services = services.filter((s) => {
        return s !== service;
      });
    } else {
      selectedServices.push(service);
    }
    setSelectedServices(services);
    setSelectedService(key);
    const target = document.getElementById(`service-${service.id}`);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };
  const handleTabChange = () => {
    setDisplay3DFloorplan(!display3DFloorplan);
    set3DBiggerArea(false);
    set3DWithFurnitures(false);
    set2DBiggerArea(false);
    const serviceOffers = _.clone(service_offers);
    const index = serviceOffers.findIndex((so) => {
      return so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN;
    });
    if (index !== -1) {
      serviceOffers.splice(index, 1);
      const existingCarteMeasureIndex = _.findIndex(serviceOffers, (m: ServiceOffer) => {
        return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      if (existingCarteMeasureIndex !== -1) {
        serviceOffers.splice(existingCarteMeasureIndex, 1);
      }
      updateShootingFields({ service_offers: serviceOffers }, true);
    }
  };
  const getCurrent3DService = (isWithFurnitures: boolean, isBiggerArea: boolean) => {
    const found3DService = _.find(threeDFloorplans, (s) => {
      return (
        s.serviceOffer.service_items.withRealFurniture === isWithFurnitures &&
        s.serviceOffer.service_items.isBiggerArea === isBiggerArea
      );
    });
    if (found3DService) {
      set3DFloorplanOption(found3DService);
    }
    const _serviceOffers = _.clone(service_offers);
    const index = _serviceOffers.findIndex((so) => {
      return so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN;
    });
    if (index !== -1) {
      _serviceOffers.splice(index, 1);
      const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
        return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      if (existingCarteMeasureIndex !== -1) {
        _serviceOffers.splice(existingCarteMeasureIndex, 1);
      }
    }
    if (found3DService) {
      _serviceOffers.push(found3DService);
      const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
        return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      if (carteMeasureService && existingCarteMeasureIndex === -1) {
        _serviceOffers.push(carteMeasureService);
      }
    }
    updateShootingFields({ service_offers: _serviceOffers }, true);
  };
  const handle3DCheckbox = (e: any, type: string) => {
    switch (type) {
      case 'furnitures':
        set3DWithFurnitures(e.target.checked);
        getCurrent3DService(e.target.checked, is3DBiggerArea);
        break;
      case 'area':
        set3DBiggerArea(e.target.checked);
        getCurrent3DService(is3DWithFurnitures, e.target.checked);
        break;
      default:
        return null;
    }
    return null;
  };
  const handle2DCheckbox = (e: any) => {
    set2DBiggerArea(e.target.checked);
    const found2DService = _.find(twoDFloorplans, (s) => {
      return s.serviceOffer.service_items.isBiggerArea === e.target.checked;
    });
    if (found2DService) {
      set2DFloorplanOption(found2DService);
    }
    const _serviceOffers = _.clone(service_offers);
    const index = _serviceOffers.findIndex((so) => {
      return so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN;
    });
    if (index !== -1) {
      _serviceOffers.splice(index, 1);
      const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
        return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      if (existingCarteMeasureIndex !== -1) {
        _serviceOffers.splice(existingCarteMeasureIndex, 1);
      }
    }
    if (found2DService) {
      _serviceOffers.push(found2DService);
      const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
        return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      if (carteMeasureService && existingCarteMeasureIndex === -1) {
        _serviceOffers.push(carteMeasureService);
      }
    }
    updateShootingFields({ service_offers: _serviceOffers }, true);
  };
  const getServiceIcon = (category) => {
    switch (category.icon_name) {
      case 'floorplan':
        return images.floorplan;
      case 'staging':
        return images.staging;
      case 'drone':
        return images.drone;
      case 'video':
        return images.video;
      case 'upload_picture':
        return images.upload_picture;
      case 'blue_hour':
        return images.blue_hour;
      case 'seasonal':
        return images.seasonal;
      case 'signature':
        return images.signature;
      case 'matterport':
        return images.matterport_svg;
      default:
        return null;
    }
  };
  const getSelectedServicesCount = (icon_name: string) => {
    let count = 0;
    const foundSameCategoryServices = [];
    // eslint-disable-next-line array-callback-return
    shooting.service_offers.map((so) => {
      if (so?.serviceOffer?.category?.icon_name === icon_name && !so.is_child) {
        foundSameCategoryServices.push(so.serviceOffer);
      }
    });
    // eslint-disable-next-line array-callback-return
    foundSameCategoryServices.map((so) => {
      if (so?.category?.icon_name === icon_name) {
        count++;
      }
    });
    return count;
  };
  const onClickTooltip = (service) => {
    setShowTooltipModal(true);
    setTooltipService(service.serviceOffer);
  };
  const onTooltipClose = () => {
    setShowTooltipModal(false);
  };
  const renderServices = () => {
    if (!serviceOffers.length) return null;
    const services = serviceOffers.filter((service) => {
      return (
        service.serviceOffer.price &&
        service.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SAME_DAY_DELIVERY &&
        service.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE &&
        service.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.CARTE &&
        service.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
        service.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.DRONE
      );
    });
    const freeServices = serviceOffers.filter((service) => {
      return !service.serviceOffer.price;
    });
    const recommendedServices = serviceOffers.filter((service) => {
      return service.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.CARTE;
    });
    const groupedServices = _.groupBy(services, (service) => {
      return service.serviceOffer.category.order_index;
    });
    const render3DFloorplanCheckbox = () => {
      if (threeDFloorplanOption) {
        return (
          <div className={styles.checkboxContent}>
            <div className={styles.checkboxRow}>
              <Typography className={styles.checkboxText}>{fmtWithRealFurnitures}</Typography>
              <Checkbox
                checked={is3DWithFurnitures}
                onChange={(e) => {
                  return handle3DCheckbox(e, 'furnitures');
                }}
              />
            </div>
            <div className={styles.checkboxRow}>
              <Typography className={styles.checkboxText}>{fmtLargerThan200}</Typography>
              <Checkbox
                checked={is3DBiggerArea}
                onChange={(e) => {
                  return handle3DCheckbox(e, 'area');
                }}
              />
            </div>
          </div>
        );
      }
      return null;
    };
    const render2DFloorplanCheckbox = () => {
      const foundLargerFloorplan = twoDFloorplans.find((f) => {
        return f.serviceOffer.service_items.isBiggerArea;
      });
      if (twoDFloorplanOption && foundLargerFloorplan) {
        return (
          <div className={styles.checkboxContent}>
            <div className={styles.checkboxRow}>
              <Typography>{fmtLargerThan200}</Typography>
              <Checkbox
                checked={is2DBiggerArea}
                onChange={(e) => {
                  handle2DCheckbox(e);
                }}
              />
            </div>
          </div>
        );
      }
      return null;
    };
    const renderFloorplanService = (service) => {
      if (service) {
        const isSelected = isServiceSelected(service);
        const isDisabled = isServiceDisabled(service);
        const isChild = checkIfChild(service);
        const renderDetail = () => {
          return (
            <Grid item md={7} sm={12} className={styles.serviceLeftContent}>
              <div className={styles.serviceTitleRow}>
                <Typography className={styles.serviceNameTitle}>
                  {isEnglish
                    ? service.serviceOffer.display_name
                    : service.serviceOffer.display_name_fr}
                </Typography>
              </div>
              <div className={styles.servicePriceRow}>
                <div className={styles.row}>
                  <div className={styles.priceContainer}>
                    <Typography className={styles.priceText}>
                      {`$ ${service.serviceOffer.price}`}
                    </Typography>
                  </div>
                  <div>
                    {service.serviceOffer.example ? (
                      <div className={styles.serviceTooltip}>
                        <div
                          onClick={() => {
                            return onClickTooltip(service);
                          }}
                        >
                          <img
                            style={{ height: 20, width: 20, marginLeft: 10 }}
                            src={images.info}
                            alt='info'
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              {service?.serviceOffer?.require_mls === true && listing.mls !== '' && (
                <div>
                  <Typography style={{ color: COLOR.BLUE }}>{listing.mls}</Typography>
                </div>
              )}
              {service?.serviceOffer?.items &&
                service.serviceOffer.items
                  .sort((a, b) => {
                    return a.service_offer_item.order_index - b.service_offer_item.order_index;
                  })
                  .map((item, index) => {
                    return (
                      <div key={index} className={styles.packageDescriptionRow}>
                        <img
                          style={{ width: 30, height: 30, marginRight: 10 }}
                          src={getServiceDescriptionIcon(item.service_offer_item.icon_name)}
                          alt='description icon'
                        />
                        <Typography className={styles.packageDescription}>
                          {isEnglish
                            ? item.service_offer_item.description
                            : item.service_offer_item.description_fr}
                        </Typography>
                      </div>
                    );
                  })}
              {isDisabled && (
                <Typography style={{ color: COLOR.GREY }}>{fmtDisabledHelper}</Typography>
              )}
            </Grid>
          );
        };
        const renderImage = () => {
          return (
            <Grid item md={5} sm={12} className={styles.serviceRightContent}>
              {service?.serviceOffer?.example?.image_url ? (
                <img
                  src={service?.serviceOffer?.example?.image_url}
                  className={styles.serviceExample}
                  alt='example'
                />
              ) : null}
              <div
                className={styles.overlayTick}
                onClick={() => {
                  return onToggleServiceOffer(service, isDisabled);
                }}
              >
                <div
                  className={styles.blueCircleIcon}
                  style={{
                    backgroundColor: isSelected && !isChild ? COLOR.LIGHT_BLUE : COLOR.WHITE,
                  }}
                >
                  {isSelected && !isChild ? (
                    <DoneRounded className={styles.selectedIcon} />
                  ) : (
                    <AddRoundedIcon className={styles.plus} />
                  )}
                </div>
              </div>
            </Grid>
          );
        };
        return (
          <div
            className={styles.exampleServiceContent}
            key={service.id}
            id={`service-${service.serviceOffer.id}`}
          >
            <Grid container className={styles.selectedServiceContent}>
              <div className={window.innerWidth < ipad_width ? null : styles.hideContent}>
                {renderImage()}
              </div>
              {renderDetail()}
              <div className={window.innerWidth < ipad_width ? styles.hideContent : null}>
                {renderImage()}
              </div>
            </Grid>
          </div>
        );
      }
      return <Typography className={styles.noServiceWarning}>{fmtNoServiceAvailable}</Typography>;
    };
    const renderFloorplanServices = () => {
      return (
        <div className={styles.borderContent}>
          <div className={styles.floorplanOptionsContent}>
            <div className={styles.serviceContentRow}>
              <Typography className={styles.serviceNameTitle}>{fmtFloorplanType}</Typography>
              <div className={styles.switchRow}>
                <Typography>2D</Typography>
                <Switch
                  checked={display3DFloorplan}
                  onChange={handleTabChange}
                  className={styles.switch}
                  classes={{
                    root: styles.root,
                    switchBase: styles.switchBase,
                    thumb: styles.thumb,
                    track: styles.track,
                  }}
                />
                <Typography>3D</Typography>
              </div>
            </div>
            <div className={styles.row}>
              {display3DFloorplan ? render3DFloorplanCheckbox() : render2DFloorplanCheckbox()}
            </div>
          </div>
          {renderFloorplanService(display3DFloorplan ? threeDFloorplanOption : twoDFloorplanOption)}
        </div>
      );
    };
    const getExampleImage = () => {
      if (tooltipService) {
        if (
          tooltipService.service_items.type === '3D' &&
          !tooltipService.service_items.withRealFurniture
        ) {
          return images.standard_3d;
        }
        if (
          tooltipService.service_items.type === '3D' &&
          tooltipService.service_items.withRealFurniture
        ) {
          return images.advanced_3d;
        }
      }
      return images.floorplanExample;
    };
    const renderTooltipExamplePicture = () => {
      if (tooltipService?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN) {
        return (
          <img
            src={getExampleImage()}
            alt='floorplan'
            style={{ height: 350, width: '100%', objectFit: 'contain' }}
          />
        );
      }
      if (
        tooltipService?.category?.display_name !== SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN &&
        tooltipService?.example?.before_image_url &&
        tooltipService?.example?.after_image_url
      ) {
        return (
          <div className={styles.imagesRow}>
            <div>
              <Typography className={styles.beforeImage}>{fmtBefore}</Typography>
              <img
                src={tooltipService.example.before_image_url}
                style={{ maxWidth: 250 }}
                alt='before'
              />
            </div>
            <div>
              <Typography className={styles.afterImage}>{fmtAfter}</Typography>
              <img
                src={tooltipService.example.after_image_url}
                style={{ maxWidth: 250 }}
                alt='before'
              />
            </div>
          </div>
        );
      }
      if (tooltipService.example.image_url) {
        return (
          <img
            src={tooltipService.example.image_url}
            style={{ maxWidth: 500, marginTop: 20 }}
            alt='before'
          />
        );
      }
      return null;
    };
    const renderNonFloorplanService = (
      service: ServiceOffer,
      index: number,
      displayRecommendedService: boolean,
    ) => {
      const isSelected = isServiceSelected(service);
      const isDisabled = isServiceDisabled(service);
      const isCovered = checkIfCovered(service_offers, service);
      const isPromotion = service.serviceOffer?.promotion?.id;
      const isChild = checkIfChild(service);
      if (!displayRecommendedService && isPromotion) return null;
      const renderImage = () => {
        return (
          <Grid item md={5} sm={12} className={styles.serviceRightContent}>
            {service?.serviceOffer?.example?.image_url ? (
              <img
                src={service?.serviceOffer?.example?.image_url}
                className={styles.serviceExample}
                alt='example'
              />
            ) : null}
            <div
              className={styles.overlayTick}
              onClick={() => {
                return onToggleServiceOffer(service, isDisabled);
              }}
            >
              <div
                className={styles.blueCircleIcon}
                style={{ backgroundColor: isSelected && !isChild ? COLOR.LIGHT_BLUE : COLOR.WHITE }}
              >
                {isSelected && !isChild ? (
                  <DoneRounded className={styles.selectedIcon} />
                ) : (
                  <AddRoundedIcon className={styles.plus} />
                )}
              </div>
            </div>
          </Grid>
        );
      };
      const renderDetail = () => {
        return (
          <Grid item md={7} sm={12} className={styles.serviceLeftContent}>
            <div className={styles.serviceTitleRow}>
              <Typography className={styles.serviceNameTitle}>
                {isEnglish
                  ? service.serviceOffer.display_name
                  : service.serviceOffer.display_name_fr}
              </Typography>
            </div>
            <div className={styles.servicePriceRow}>
              <div className={styles.row}>
                {isCovered && (
                  <div className={styles.coveredPriceContainer}>
                    <Typography className={styles.priceText}>0 $</Typography>
                  </div>
                )}
                <div className={isCovered ? styles.originalPriceContainer : styles.priceContainer}>
                  <Typography
                    className={styles.priceText}
                    style={{
                      textDecoration: isCovered ? 'line-through' : 'none',
                      textDecorationColor: isCovered ? COLOR.RED : 'none',
                    }}
                  >
                    {`$ ${service.serviceOffer.price}`}
                  </Typography>
                </div>
                <div>
                  {service.serviceOffer.example ? (
                    <div className={styles.serviceTooltip}>
                      <div
                        onClick={() => {
                          return onClickTooltip(service);
                        }}
                      >
                        <img
                          style={{ height: 20, width: 20, marginLeft: 10 }}
                          src={images.info}
                          alt='info'
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {service.serviceOffer.require_mls === true && listing.mls !== '' && (
              <div>
                <Typography style={{ color: COLOR.BLUE }}>{listing.mls}</Typography>
              </div>
            )}
            {service.serviceOffer.items
              .sort((a, b) => {
                return a.service_offer_item.order_index - b.service_offer_item.order_index;
              })
              .map((item, index) => {
                return (
                  <div key={index} className={styles.packageDescriptionRow}>
                    <img
                      style={{ width: 30, height: 30, marginRight: 10 }}
                      src={getServiceDescriptionIcon(item.service_offer_item.icon_name)}
                      alt='description icon'
                    />
                    <Typography className={styles.packageDescription}>
                      {isEnglish
                        ? item.service_offer_item.description
                        : item.service_offer_item.description_fr}
                    </Typography>
                  </div>
                );
              })}
            {isDisabled && (
              <Typography style={{ color: COLOR.GREY }}>{fmtDisabledHelper}</Typography>
            )}
          </Grid>
        );
      };
      return (
        <div
          className={styles.exampleServiceContent}
          key={index}
          id={`service-${service.serviceOffer.id}`}
        >
          <Grid container className={styles.selectedServiceContent}>
            <div className={window.innerWidth < ipad_width ? null : styles.hideContent}>
              {renderImage()}
            </div>
            {renderDetail()}
            <div className={window.innerWidth < ipad_width ? styles.hideContent : null}>
              {renderImage()}
            </div>
          </Grid>
        </div>
      );
    };
    const renderNonFloorplanServices = () => {
      return (
        <div className={styles.serviceContent}>
          <Typography className={styles.selectedServiceTitle}>
            {isEnglish
              ? groupedServices[selectedService][0]?.serviceOffer?.category.display_name
              : groupedServices[selectedService][0]?.serviceOffer?.category.display_name_fr}
          </Typography>
          {groupedServices[selectedService].map((service, index) => {
            return renderNonFloorplanService(service, index, false);
          })}
        </div>
      );
    };

    const renderTooltipExample = () => {
      if (tooltipService && tooltipService.example) {
        return (
          <div className={styles.tooltipModal}>
            <Typography>
              {isEnglish
                ? tooltipService.example.description
                : tooltipService.example.description_fr}
            </Typography>
            {renderTooltipExamplePicture()}
          </div>
        );
      }
      return null;
    };
    const renderServiceOffers = () => {
      const sortedServices = [];
      Object.keys(groupedServices).forEach((key) => {
        const categoryServices = groupedServices[key];
        categoryServices.map((service) => {
          return sortedServices.push(service);
        });
      });
      return Object.keys(groupedServices).map((key) => {
        const categoryServices = groupedServices[key];
        if (
          categoryServices[0].serviceOffer.category.display_name ===
          SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN
        ) {
          return renderFloorplanServices();
        }
        return categoryServices.map((service, index) => {
          return renderNonFloorplanService(service, index, false);
        });
      });
    };
    const renderRecommendedServices = () => {
      return (
        <div>
          <Typography className={styles.categoryTitle}>{fmtRecommendedServices}</Typography>
          <div>
            {recommendedServices.map((service, index) => {
              return renderNonFloorplanService(service, index, true);
            })}
          </div>
        </div>
      );
    };
    const renderAdditionalServices = () => {
      return (
        <div>
          <Typography className={styles.categoryTitle}>{fmtAdditionalServices}</Typography>
          <Grid container spacing={1} className={styles.servicesContent}>
            {Object.keys(groupedServices).map((key, index) => {
              const { icon_name } = groupedServices[key][0]?.serviceOffer?.category;
              return (
                <Grid
                  item
                  sm={2}
                  xs={4}
                  md={2}
                  className={styles.countContent}
                  key={index}
                  onClick={() => {
                    return onClickCategory(Number(key), groupedServices[key][0].serviceOffer);
                  }}
                >
                  <Card
                    variant='outlined'
                    raised
                    className={
                      Number(key) === selectedService
                        ? styles.selectedServiceContainer
                        : styles.serviceContainer
                    }
                  >
                    {getSelectedServicesCount(icon_name) ? (
                      <div className={styles.count}>
                        <Typography className={styles.countNumber}>
                          {getSelectedServicesCount(icon_name)}
                        </Typography>
                      </div>
                    ) : null}
                    <img
                      src={getServiceIcon(groupedServices[key][0].serviceOffer.category)}
                      style={{ width: 40 }}
                      alt='service icon'
                    />
                    <Typography className={styles.serviceTitle}>
                      {isEnglish
                        ? groupedServices[key][0].serviceOffer.category.display_name
                        : groupedServices[key][0].serviceOffer.category.display_name_fr}
                    </Typography>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
          <div className={styles.serviceItemsContent}>{renderServiceOffers()}</div>
          <Dialog open={showTooltipModal} onClose={onTooltipClose}>
            <DialogTitle>
              <Typography className={styles.boldFont}>
                {isEnglish ? tooltipService?.display_name : tooltipService?.display_name_fr}
              </Typography>
            </DialogTitle>
            {renderTooltipExample()}
          </Dialog>
        </div>
      );
    };
    const renderFreeServices = () => {
      return (
        <div className={styles.freeServicesContent}>
          <Typography className={styles.categoryTitle}>{fmtAddForFree}</Typography>
          {freeServices.map((service, index) => {
            const isSelected = isServiceSelected(service);
            const isDisabled = isServiceDisabled(service);
            return (
              <div
                className={styles.serviceContent}
                key={index}
                onClick={() => {
                  return onToggleServiceOffer(service, isDisabled);
                }}
              >
                <Typography className={styles.boldFont}>
                  {isEnglish
                    ? service.serviceOffer.display_name
                    : service.serviceOffer.display_name_fr}
                </Typography>
                <div key={index} className={styles.servicePriceRow}>
                  <Typography className={styles.packageDescription}>{fmtFreeServices}</Typography>
                  <div className={styles.tick}>
                    <div className={styles.blueCircleIcon}>
                      {isSelected ? (
                        <DoneRounded className={styles.plus} />
                      ) : (
                        <AddRoundedIcon className={styles.plus} />
                      )}
                    </div>
                  </div>
                </div>
                <div className={styles.packageDescriptionRow}>
                  <img
                    style={{ width: 25, height: 25, marginRight: 10 }}
                    src={images.upload_picture}
                    alt='upload icon'
                  />
                  <Typography>
                    {isEnglish
                      ? service.serviceOffer.description
                      : service.serviceOffer.description_fr}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      );
    };
    return (
      <div className={styles.group}>
        {recommendedServices.length ? renderRecommendedServices() : null}
        {services.length ? renderAdditionalServices() : null}
        {freeServices.length === 0 ? null : renderFreeServices()}
      </div>
    );
  };

  return (
    <>
      <div className={classNames('ScrollView', styles.stepContent)}>
        {loading ? <HvPleaseWait className={styles.wait} /> : <>{renderServices()}</>}
      </div>

      <div className='ButtonsBox'>
        <div className={styles.buttons}>
          <Button variant='contained' className='BackButton' onClick={onCancel}>
            {fmtCancel}
          </Button>
          <Button
            className={styles.saveButton}
            variant='contained'
            color='secondary'
            onClick={onUpdate}
          >
            <SaveRoundedIcon />
            <Typography className={styles.buttonText}>
              {isDraftMode || !shooting.id ? fmtSaveDraft : fmtSave}
            </Typography>
          </Button>
        </div>

        <div className={styles.buttons}>
          <Button className={styles.backButton} variant='outlined' onClick={onPreviousStep}>
            <ChevronLeftRoundedIcon />
            {fmtBack}
          </Button>

          <Button
            variant='contained'
            color='secondary'
            className={styles.nextButton}
            onClick={onNextStep}
          >
            {`${fmtNext} (4/5)`}
          </Button>
        </div>
      </div>
    </>
  );
}

export default ServiceStep;
